import { type ArticleCollections, CollectionContentTypes, CollectionWithCreationDate, CollectionWithId } from '@pressreader/social-types';

import type { CollectionDtoWithCreationDate, CollectionDtoWithOptionalCreationDate, WithCollectionsDto } from '../types';

import { mapCollectionsDto } from './collections.common';

function mapArticleCollections(
    articleId: string,
    objWithCollectionsDto: WithCollectionsDto<CollectionDtoWithOptionalCreationDate>,
): typeof objWithCollectionsDto extends CollectionDtoWithCreationDate
    ? ArticleCollections & { collections: CollectionWithCreationDate[] }
    : ArticleCollections & { collections: CollectionWithId[] } {
    return {
        ...mapCollectionsDto(objWithCollectionsDto),
        articleId,
        collectionContent: CollectionContentTypes.article,
    };
}

export { mapArticleCollections };
